/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ speakerName: NonNullable<unknown> }} Speakers_Add_Recipient_Aria_LabelInputs */

const en_speakers_add_recipient_aria_label = /** @type {(inputs: Speakers_Add_Recipient_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Add ${i?.speakerName} as recipient`)
};

const fr_speakers_add_recipient_aria_label = /** @type {(inputs: Speakers_Add_Recipient_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ajouter ${i?.speakerName} en tant que destinataire`)
};

const de_speakers_add_recipient_aria_label = /** @type {(inputs: Speakers_Add_Recipient_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Füge ${i?.speakerName} als Empfänger hinzu`)
};

const it_speakers_add_recipient_aria_label = /** @type {(inputs: Speakers_Add_Recipient_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aggiungi ${i?.speakerName} come destinatario`)
};

const ru_speakers_add_recipient_aria_label = /** @type {(inputs: Speakers_Add_Recipient_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Добавить ${i?.speakerName} в качестве получателя`)
};

const es_speakers_add_recipient_aria_label = /** @type {(inputs: Speakers_Add_Recipient_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Agregar ${i?.speakerName} como destinatario`)
};

const zh_cn2_speakers_add_recipient_aria_label = /** @type {(inputs: Speakers_Add_Recipient_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`添加 ${i?.speakerName} 为收件人`)
};

const ja_speakers_add_recipient_aria_label = /** @type {(inputs: Speakers_Add_Recipient_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.speakerName} を受信者として追加`)
};

const hi_speakers_add_recipient_aria_label = /** @type {(inputs: Speakers_Add_Recipient_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.speakerName} को प्राप्तकर्ता के रूप में जोड़ें`)
};

const pt_pt2_speakers_add_recipient_aria_label = /** @type {(inputs: Speakers_Add_Recipient_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Adicionar ${i?.speakerName} como destinatário`)
};

/**
* | output |
* | --- |
* | "Add {speakerName} as recipient" |
*
* @param {Speakers_Add_Recipient_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_add_recipient_aria_label = /** @type {((inputs: Speakers_Add_Recipient_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Add_Recipient_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_add_recipient_aria_label(inputs)
	if (locale === "de") return de_speakers_add_recipient_aria_label(inputs)
	if (locale === "it") return it_speakers_add_recipient_aria_label(inputs)
	if (locale === "ru") return ru_speakers_add_recipient_aria_label(inputs)
	if (locale === "es") return es_speakers_add_recipient_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_add_recipient_aria_label(inputs)
	if (locale === "ja") return ja_speakers_add_recipient_aria_label(inputs)
	if (locale === "hi") return hi_speakers_add_recipient_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_add_recipient_aria_label(inputs)
	return en_speakers_add_recipient_aria_label(inputs)
});